import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Skeleton } from '@/components/ui/skeleton'
import { useDomainsQuery } from '@/hooks/api/use-domains-query'
import { useSplitView } from '../split-view/split-view-context'
import { isStaticTab } from '../split-view/tabs/types'
import { useDomainIdQueryState } from './use-domain-from-url'
function DomainSelect() {
  const { filterTabs } = useSplitView()
  const { status, data: domains } = useDomainsQuery()
  const { domainId, setDomainId } = useDomainIdQueryState()

  return (
    <Select
      value={domainId}
      onValueChange={(v) => {
        filterTabs({ predicate: (t) => !isStaticTab(t) })
        setDomainId(v)
      }}
    >
      <SelectTrigger
        name='domain'
        title='Select domain'
        disabled={status === 'pending'}
        isDirty
        className='max-w-[260px] bg-transparent [&>span]:text-neutral-150'
      >
        {status === 'pending' ? (
          <div className='w-full'>
            <Skeleton className='h-5' />
          </div>
        ) : (
          <SelectValue />
        )}
      </SelectTrigger>
      {Boolean(domains?.length) && (
        <SelectContent>
          {domains?.map(({ externalId, name }) => (
            <SelectItem key={externalId} value={externalId}>
              {name}
            </SelectItem>
          ))}
        </SelectContent>
      )}
    </Select>
  )
}

export { DomainSelect }
